import { ReactComponent as MenuOpenIcon } from '../../assets/Icons/adornments/MenuOpen.svg';
import { useState, MouseEvent, ReactNode } from "react";
import { Drawer } from "@mui/material";
import PopupHeader from "../Popups/PopupHeader";
import { ColumnMetadataOutputClassOrigin, ColumnMetadataOutputDataType, ColumnMetadataOutputDescription, ColumnMetadataOutputStats, ColumnMetadataOutputUnits } from "../../api/models";

export default function ColumnMetadataMenu({
    label,
    columnMetadata,
}: {
    label: string,
    columnMetadata: {
        column_name: string,
        data_type?: ColumnMetadataOutputDataType,
        stats?: ColumnMetadataOutputStats,
        description?: ColumnMetadataOutputDescription,
        units?: ColumnMetadataOutputUnits,
        class_origin?: ColumnMetadataOutputClassOrigin,
    },
}) {
    const [ open, setOpen ] = useState(false);

    const toggleDrawer = (isOpen: boolean) => {
        setOpen(isOpen);
    }

    const InfoContainer = ({ label, children }: { label: string, children: ReactNode }) => {
        return (
            <div className="w-full flex flex-col gap-1 justify-start items-start">
                <label className="font-medium text-[12px]">{label}</label>
                {children}
            </div>
        )
    }

    return (
        <>
        <button onClick={(e: MouseEvent<HTMLButtonElement>) => toggleDrawer(true)} className="w-[18px] text-disable hover:text-primary">
            <MenuOpenIcon/>
        </button>
        <Drawer
            anchor="right"
            open={open}
            onClose={() => toggleDrawer(false)}
        >
            <div className="w-[450px] h-full flex flex-col justify-start items-stretch bg-white rounded-tl-2xl rounded-bl-2xl">
                <PopupHeader 
                    label={label}
                    hasOutline={true}
                    collapseFn={(e: MouseEvent<HTMLButtonElement>) => toggleDrawer(false)}
                />
                <div className="grow overflow-y-auto">
                    <div className="w-full p-6 flex flex-col gap-8 justify-start items-stretch">
                        <InfoContainer label='Column Name'>
                            <p className='text-default'>{columnMetadata.column_name}</p>
                        </InfoContainer>
                        <div className="w-full flex justify-between items-center gap-6">
                            {columnMetadata.data_type && (
                                <InfoContainer label='Data Type'>
                                    <p className='text-default'>{columnMetadata.data_type}</p>
                                </InfoContainer>
                            )}
                            {columnMetadata.units && (
                                <InfoContainer label='Units'>
                                    <p className='text-default'>{columnMetadata.units}</p>
                                </InfoContainer>
                            )}
                        </div>
                        {columnMetadata.description && (
                            <InfoContainer label='Description'>
                                <p className='text-default'>{columnMetadata.description}</p>
                            </InfoContainer>
                        )}
                        {columnMetadata.stats && (
                            <div className="grid grid-cols-2 auto-rows-auto gap-x-6 gap-y-8">
                                {Object.keys(columnMetadata.stats).map(stat => {
                                    const value = columnMetadata.stats![stat];
                                    return (
                                        <InfoContainer label={stat}>
                                            <p className='text-default'>{value as string}</p>
                                        </InfoContainer>
                                    )
                                })}
                            </div>
                        )}
                        
                        
                    </div>
                </div>
            </div>
        </Drawer>

        </>
    )
}